
import React from "react";
import { DetailedHTMLProps, FC, SVGProps } from "react";
export const AddIcon: FC<
DetailedHTMLProps<SVGProps<SVGSVGElement>, SVGSVGElement>
> = ({className}) => (

    <svg className={className} width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3.97314 0.761597L3.97314 6.7616M6.97314 3.7616L3.97314 3.7616L0.973145 3.7616" stroke="#555555" stroke-width="1.5" stroke-linecap="round"/>
    </svg>

);